import { colors } from "@hubrise/react-components"
import styled from "styled-components"

export const StyledExpanded = styled.div`
  position: relative;
`

export const Title = styled.div`
  font-weight: 500;
  padding: 1rem;
  cursor: pointer;

  :hover {
    background-color: ${colors.backgroundLighter};
  }
`

export const OptionLists = styled.div`
  padding: 1rem;
  background-color: ${colors.backgroundLightest};
  display: flex;
  flex-direction: column;
  gap: 2.5rem;
`
